import { useEffect, useRef, useState } from "react";
import { Skeleton, Toast } from "react-vant";
import { useSearchParams } from "react-router-dom";
import Sound from "./Sound";
import "./StudyReport.less";
import { lessonReport } from "api/inter";
import { getSpeakAudio } from "api/teacher";
export default function StudyReport() {
  const [reportData, setReportData] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPlay, setCurrentPlay] = useState(null);
  const audioRef = useRef(null);
  const [params] = useSearchParams();
  async function handleClickPlay(index, type, data) {
    if (!currentPlay || currentPlay !== `${type}-${index}`) {
      audioRef.current.pause();
      if (type === "student") {
        if (data.bin_data) {
          audioRef.current.src = `${process.env.REACT_APP_API_CDN}/${data.bin_data}`;
        } else {
          return Toast.info("暂无音频");
        }
      } else {
        Toast.loading({
          message: "教师音频加载中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        const teacherRes = await getSpeakAudio({
          token: encodeURIComponent(reportData?.comment?.token),
          voice_id: reportData?.comment?.voice_id,
          text: data.answer,
        });
        Toast.clear();
        if (teacherRes.code === 200) {
          audioRef.current.src = `data:audio/wav;base64,${teacherRes.data}`;
        }
      }
      audioRef.current.currentTime = 0;
      audioRef.current.play();
      setCurrentPlay(`${type}-${index}`);
    } else {
      audioRef.current.pause();
    }
  }
  async function getLessonReport(id) {
    const res = await lessonReport(id);
    if (res.code === 200) {
      if (Array.isArray(res?.data?.list)) {
        res.data.list = res.data.list.map((item) => {
          try {
            item.bin_data = JSON.parse(item.bin_data)[0];
          } catch {
            item.bin_data = "";
          }
          return item;
        });
      }
      setReportData(res.data);
      setLoading(false);
    }
  }
  function transformScore(score) {
    if (typeof score !== "number") {
      return "--";
    }
    if (score >= 90) {
      return "很好";
    }
    if (score >= 60 && score < 90) {
      return "一般";
    }
    if (score < 60) {
      return "待加强";
    }
  }
  useEffect(() => {
    getLessonReport(params.get("id"));
    audioRef.current = new Audio();
    function handleStop() {
      audioRef.current.src = "";
      setCurrentPlay(null);
    }
    audioRef.current.addEventListener("pause", handleStop);
    audioRef.current.addEventListener("ended", handleStop);
    return () => {
      audioRef.current.removeEventListener("pause", handleStop);
      audioRef.current.removeEventListener("ended", handleStop);
    };
  }, []);
  return (
    <div className="report-container">
      <Skeleton loading={loading} row={5} rowHeight={20} title>
        <div className="hd">
          <div className="hd-id">{`ClassId:${params.get("id") || ""}`}</div>
          <div className="hd-black">
            <p className="hd-black-course">
              <span>{reportData?.header?.studentName || "--"}</span>
              {/* <span className="hd-black-course--title">{`【${
                reportData?.header?.title || "--"
              }】`}</span>
              <span>的学习</span> */}
            </p>
            <p className="hd-black-text">
              <span>{reportData?.header?.level || "--"}</span>
              <span className="color-1">
                {reportData?.header?.title || "--"}
              </span>
              {/* <img
                className="hd-black-text-diamond--left"
                src={require("@/images/report/black-diamond.png")}
              />
              <span className="hd-black-text--name">
                {reportData?.header?.studentName || "--"}
              </span>
              <span>/宝贝</span>
              <img
                className="hd-black-text-diamond--right"
                src={require("@/images/report/black-diamond.png")}
              /> */}
            </p>
            <img
              className="hd-duck"
              src={require("@/images/report/hd-duck.png")}
            />
            <img
              className="hd-ubao"
              src={require("@/images/report/hd-ubao.png")}
            />
            <img
              className="hd-hello"
              src={require("@/images/report/hd-hello.png")}
            />
          </div>
        </div>
        <div className="bd">
          <div className="bd-el-container">
            <div className="report">
              <div className="report-title">学习报告</div>
              <div className="report-block">
                <div className="block-vocabulary">
                  <div>
                    <span className="block-vocabulary-num">
                      {reportData?.header?.vocabulary || "--"}
                    </span>
                    <span className="block-vocabulary-unit">个</span>
                  </div>
                  <div className="block-vocabulary-name">词汇量</div>
                </div>
                <div className="block-sentence">
                  <div>
                    <span className="block-sentence-num">
                      {reportData?.header?.sentence || "--"}
                    </span>
                    <span className="block-sentence-unit">个</span>
                  </div>
                  <div className="block-sentence-name">句型量</div>
                </div>
                <div className="block-grade">
                  <div>
                    <span className="block-grade-num">
                      {(reportData?.header?.level &&
                        reportData?.header?.level.split(" ")[0]) ||
                        "--"}
                    </span>
                    <span className="block-grade-unit">
                      {(reportData?.header?.level &&
                        reportData?.header?.level.split(" ")[1]) ||
                        "--"}
                    </span>
                  </div>
                  <div className="block-grade-name">当前等级</div>
                </div>
              </div>
              <div className="report-schedule">
                <div>{`等级进度(${reportData?.header?.step || "--"}/${
                  reportData?.header?.count || "--"
                })`}</div>
                <div>{reportData?.header?.level || "--"}</div>
              </div>
              <div className="report-progress">
                <div
                  className="bar"
                  style={{
                    width:
                      typeof reportData?.header?.step === "number" &&
                      typeof reportData?.header?.count === "number"
                        ? `${
                            (reportData?.header?.step /
                              reportData?.header?.count) *
                            100
                          }%`
                        : "0%",
                  }}
                ></div>
              </div>
            </div>
            <div className="connect-container">
              <img
                className="mark-left"
                src={require("@/images/report/connect.png")}
              />
              <img
                className="mark-right"
                src={require("@/images/report/connect.png")}
              />
            </div>
            <div className="percentage">
              <div className="percentage-center">
                <img
                  className="percentage-center-ubao"
                  src={require("@/images/report/percentage-ubao.png")}
                />
              </div>
              {[...new Array(4)].map((item, index) => (
                <img
                  className={`percentage-line-${index + 1}`}
                  key={`percentage-line-${index + 1}`}
                  src={require(
                    `@/images/report/percentage-line-${index + 1}.png`
                  )}
                />
              ))}
              {[...new Array(4)].map((item, index) => (
                <img
                  className={`percentage-round-${index + 1}`}
                  key={`percentage-round-${index + 1}`}
                  src={require("@/images/report/percentage-img-round.png")}
                />
              ))}
              {[...new Array(4)].map((item, index) => (
                <img
                  className={`percentage-icon-${index + 1}`}
                  key={`percentage-img-${index + 1}`}
                  src={require(
                    `@/images/report/percentage-img-${index + 1}.png`
                  )}
                />
              ))}
              <div className="percentage-text-1">
                <div className="title">
                  <span className="fill">
                    {reportData?.tables?.sayCount || "--"}
                  </span>
                  <span className="fill">次</span>
                </div>
                <div className="text">开口次数</div>
              </div>
              <div className="percentage-text-2">
                <div className="title">
                  <span className="fill">
                    {reportData?.tables?.intentCount
                      ? `${reportData?.tables?.intentCount}`
                      : "--"}
                  </span>
                </div>
                <div className="text">语义平均分</div>
              </div>
              <div className="percentage-text-3">
                <div className="title">
                  <span className="fill">
                    {reportData?.tables?.voiceCount
                      ? `${reportData?.tables?.voiceCount}`
                      : "--"}
                  </span>
                </div>
                <div className="text">语音平均分</div>
              </div>
              <div className="percentage-text-4">
                <div className="title">
                  <span className="fill">
                    {reportData?.tables?.starCount || "--"}
                  </span>
                </div>
                <div className="text">得分数</div>
              </div>
            </div>
            <div className="connect-container">
              <img
                className="mark-left"
                src={require("@/images/report/connect.png")}
              />
              <img
                className="mark-right"
                src={require("@/images/report/connect.png")}
              />
            </div>
            {reportData?.list && reportData.list.length > 0 && (
              <div className="classroom">
                <img
                  className="classroom-title"
                  src={require("@/images/report/classroom-title.png")}
                />
                <div className="classroom-head">
                  <span className="classroom-head-me">宝贝发音</span>
                  <span className="classroom-head-teacher">外教发音</span>
                  <span className="classroom-head-eval">评价</span>
                </div>
                {reportData.list.map((item, index) => (
                  <div className="classroom-item" key={`wav-${index}`}>
                    <div className="classroom-item-word">
                      {item.answer || "--"}
                    </div>
                    <div className="classroom-item-medium">
                      <Sound
                        currentPlay={currentPlay}
                        data={item}
                        handleClickPlay={handleClickPlay}
                        index={index}
                        type={"student"}
                      />
                      <Sound
                        currentPlay={currentPlay}
                        data={item}
                        handleClickPlay={handleClickPlay}
                        index={index}
                        type={"teacher"}
                      />
                      <div className="classroom-item-medium-comment">
                        {transformScore(item.voice_score)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="connect-container">
              <img
                className="mark-left"
                src={require("@/images/report/connect.png")}
              />
              <img
                className="mark-right"
                src={require("@/images/report/connect.png")}
              />
            </div>
            <div className="foreign">
              <img
                className="foreign-title"
                src={require("@/images/report/foreign-title.png")}
              />
              <div className="foreign-body">
                <div className="foreign-body-head">
                  <img
                    className="avatar"
                    src={require("@/images/report/foreign-head.png")}
                  />
                  <img
                    className="name"
                    src={require("@/images/report/foreign-name.png")}
                  />
                  <div className="text">{reportData?.comment?.teacher}</div>
                </div>
                <div className="foreign-body-ch">
                  {reportData?.comment?.cntitle}
                </div>
                <div className="foreign-body-en">
                  {reportData?.comment?.entitle}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Skeleton>
    </div>
  );
}
